var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookWhiteGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 32,
    stroke: "url(#paint0_linear_1159_190)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1644 47.1282H30.3442V34.7297H27.4355V29.9518H30.3442V27.0857C30.3442 23.1907 31.9863 20.8718 36.6521 20.8718H40.5361V25.6497H38.1093C36.2925 25.6497 36.1717 26.3166 36.1717 27.5629L36.1644 29.9518H40.5638L40.0484 34.7297H36.1644V47.1282V47.1282Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1159_190",
    x1: 2,
    y1: 66,
    x2: 66,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697676,
    stopColor: "#BB2E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D02670"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhiteGradient);
export default __webpack_public_path__ + "static/media/FacebookWhiteGradient.933e32b5fe8051bf4519ea9c7092c47b.svg";
export { ForwardRef as ReactComponent };